module.exports = __webpack_public_path__ + "img/4k.19208cc5.jpg";